export default "__VITE_ASSET__CcprPK5I__"